export const POPADS = {
  id: 16,
  name: "Popup",
  price: null,
  is_available: "1",
  value: 16,
  label: "Popup",
};
